var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.781,
    height: 14.04,
    viewBox: "0 0 16.781 14.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(0.002 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69",
    "data-name": "Trazado 69",
    d: "M57.96,62.07h4.6a.986.986,0,0,1,.633.22.735.735,0,0,1,.249.5,6.107,6.107,0,0,1,.023.692c0,.285.01.571,0,.855-.03.693-.338.967-.982.971-.871.005-1.741,0-2.612,0q-3.2,0-6.405,0a1.605,1.605,0,0,1-1.053-.383c-.3-.245-.622-.468-.941-.689a.6.6,0,0,1-.288-.758.632.632,0,0,1,.21-.25c.278-.222.566-.433.85-.647a4.508,4.508,0,0,1,.525-.379,1.289,1.289,0,0,1,.626-.136q1.805,0,3.609,0h.965v0Z",
    transform: "translate(-46.685 -56.673)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M56.772,3.212c-1.142,0-2.283,0-3.425,0a1.659,1.659,0,0,1-1.042-.39c-.332-.253-.67-.5-1-.751a.571.571,0,0,1-.2-.7.646.646,0,0,1,.2-.232c.247-.192.5-.372.755-.559.178-.133.35-.276.53-.407A1.111,1.111,0,0,1,53.253,0C53.8-.007,54.352,0,54.9,0Q57.572,0,60.244,0a1,1,0,0,1,.6.124.794.794,0,0,1,.241.25,1.131,1.131,0,0,1,.146.568c-.008.472.005.946-.008,1.418a.838.838,0,0,1-.3.668.946.946,0,0,1-.6.188q-1.772,0-3.544,0V3.211Z",
    transform: "translate(-46.615 0)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71",
    "data-name": "Trazado 71",
    d: "M56.877,124.576c1.214,0,2.427.006,3.641,0a.768.768,0,0,1,.76.633c.01.139.04.278.042.417.005.408.015.816,0,1.223a1.323,1.323,0,0,1-.133.555.752.752,0,0,1-.7.369q-2.916,0-5.831,0H53.325a1.118,1.118,0,0,1-.68-.214c-.293-.216-.585-.433-.877-.649-.128-.094-.258-.184-.385-.279a.588.588,0,0,1,.055-.958c.385-.272.757-.562,1.135-.843a1.2,1.2,0,0,1,.75-.257c1.184.009,2.369,0,3.554,0v0Z",
    transform: "translate(-46.712 -113.735)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72",
    "data-name": "Trazado 72",
    d: "M1.607,124.647a1.582,1.582,0,0,1,1.6,1.671,1.562,1.562,0,0,1-1.661,1.518A1.557,1.557,0,0,1,0,126.21a1.576,1.576,0,0,1,1.608-1.564Z",
    transform: "translate(0 -113.804)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73",
    "data-name": "Trazado 73",
    d: "M3.289,63.866a1.572,1.572,0,0,1-1.5,1.636,1.572,1.572,0,0,1-1.7-1.534A1.545,1.545,0,0,1,1.672,62.3a1.583,1.583,0,0,1,1.617,1.563Z",
    transform: "translate(-0.082 -56.885)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M3.326,1.53A1.566,1.566,0,0,1,1.745,3.273,1.531,1.531,0,0,1,.14,1.658,1.536,1.536,0,0,1,1.707.067,1.579,1.579,0,0,1,3.326,1.53Z",
    transform: "translate(-0.129 -0.066)",
    fill: "#434343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.59deae2f9e6f6384bc2eb03f923b1869.svg";
export { ForwardRef as ReactComponent };